const Admin = () => import(/* webpackChunkName: "proj" */ './Admin');
const Appl = () => import(/* webpackChunkName: "proj" */ './Appl');

export default {
  routes: [
    {
      path: '/proj/admin',
      name: 'porj_admin',
      component: Admin,
      meta:{public:true}
    },
    {
      path: '/proj/appl',
      name: 'proj_appl',
      component: Appl,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/proj/router.js